// floating search button desktop
export const FloatingSearchAnalytics ={
    Desktop: 'floating_search_button_desktop',
    Category: 'Floating_Search',
    Mobile: 'floating_search_button_mobile',
    Text: 'Search'
}

export const AccessoryAnalytics ={
    Category: 'Accessory',
    AddText: 'Add_Accessory',
    RemoveText: 'Remove_Accessory',
    QuantityIncrease: 'Accessory_Quantity_increase',
    QuantityDecrease: 'Accessory_Quantity_decrease',
    QuantityRemove: 'Accessory_Quantity_remove',
    Displayed: 'Selected_Accessories_Displayed',
    SelectorDisplayed: 'Accessory_Selector_Displayed'
}

export const NavigationAnalytics = {
    Category: 'Navigation',
    Home: 'Navigate_Home',
    About: 'Navigate_About',
    Contact: 'Navigate_Contact',
    Blogs: 'Navigate_Blogs',
    Profile: 'Navigate_Profile',
    Back: 'Navigate_Back',
    Logout: 'User_Logout'
}

export const BookingAnalytics = {
    Category: 'Booking',
    Start: 'Booking_Start',
    Complete: 'Booking_Complete',
    Cancel: 'Booking_Cancel',
    ViewDetails: 'View_Booking_Details',
    BookNow: 'Book_Now_Button'
}

export const PaymentAnalytics = {
    Category: 'Payment',
    Initiate: 'Payment_Initiate',
    Complete: 'Payment_Complete',
    MethodSelect: 'Payment_Method_Select',
    ReviewPay: 'Review_And_Pay'
}

export const SearchAnalytics = {
    Category: 'Search',
    Filter: 'Apply_Filter',
    ClearFilter: 'Clear_Filter',
    Sort: 'Sort_Results',
    DateSelect: 'Date_Selection',
    TimeSelect: 'Time_Selection'
}

export const ModalAnalytics = {
    Category: 'Modal',
    Open: 'Modal_Open',
    Close: 'Modal_Close',
    OutsideClick: 'Modal_Outside_Click'
}

export const DateRangeAnalytics = {
    Category: 'Date_Range',
    DateSelect: 'Date_Selection',
    TimeSelect: 'Time_Selection',
    ClearAll: 'Clear_Date_Range',
    Close: 'Close_Date_Picker'
}

export const AuthAnalytics = {
    Category: 'Authentication',
    Login: 'User_Login',
    Logout: 'User_Logout',
    SendOtp: 'Send_OTP',
    VerifyOtp: 'Verify_OTP',
    CompleteProfile: 'Complete_Profile'
}

export const ProfileAnalytics = {
    Category: 'Profile',
    PageVisit: 'Profile_Page_Visit',
    EditProfile: 'Edit_Profile',
    ViewRides: 'View_Rides',
    TabSwitch: 'Switch_Tab',
    UpcomingRides: 'Upcoming_Rides',
    CompletedRides: 'Completed_Rides',
    CancelledRides: 'Cancelled_Rides'
}

export const FAQAnalytics = {
    Category: 'FAQ',
    CategorySelect: 'FAQ_Category_Select',
    QuestionExpand: 'FAQ_Question_Expand',
    QuestionCollapse: 'FAQ_Question_Collapse'
}

export const ContactAnalytics = {
    Category: 'Contact',
    Submit: 'Contact_Form_Submit',
    WhatsApp: 'WhatsApp_Contact',
    Phone: 'Phone_Contact'
}

export const CompareAnalytics = {
    Category: 'Compare',
    AddToCompare: 'Add_To_Compare',
    RemoveFromCompare: 'Remove_From_Compare',
    ViewCompare: 'View_Compare',
    ClearCompare: 'Clear_Compare'
}

export const DeliveryAnalytics = {
    Category: 'Delivery',
    OptionSelect: 'Delivery_Option_Select',
    AddressSubmit: 'Address_Submit',
    AddressModal: 'Address_Modal'
}

export const PWAAnalytics = {
    Category: 'PWA',
    Install: 'PWA_Install',
    InstallPrompt: 'PWA_Install_Prompt'
}

